export default __webpack_public_path__ + "static/media/a011-fsi-03.ed22ecac.svg";